import React from "react";
import Card from "./Card";
import BusinessCard from "./BusinessCard";
import EventCard from "../events/EventCard";
import NoRecordFound from "./NoRecordFound";
import Pagination from "./Pagination";
import Divider from "./Divider";

function SearchResults({ data, dataPage, queryLocation, queryPage, paginationData, handlePagination, queryCategory, queryLocation: queryLoc, querySort, queryLimit }) {
  let nearestLocation = 0;
  let currentLocationFlag = 0;
  let pillsimilar = null;
  let nearBy = "";

  return (
    <div className="row">
      {data
        ? data.map((element, index, lastIndex) => {
            if (element.page === "business") {
              pillsimilar = element.category.charAt(0).toUpperCase() + element.category.slice(1);
            } else if (element.page === "job") {
              pillsimilar = element.type.charAt(0).toUpperCase() + element.type.slice(1);
            } else if (element.page === "property") {
              pillsimilar = element.property_type.charAt(0).toUpperCase() + element.property_type.slice(1);
            } else if (element.page === "event") {
              pillsimilar = element.type.charAt(0).toUpperCase() + element.type.slice(1);
            }

            if (parseInt(queryLocation) !== parseInt(element.location_id)) {
              nearestLocation = nearestLocation + 1;
            }
            if (parseInt(queryLocation) === parseInt(element.location_id)) {
              currentLocationFlag = currentLocationFlag + 1;
            }

            if (dataPage === "property") {
              nearBy = "Similar properties near by";
            } else if (dataPage === "event") {
              nearBy = "Similar events near by";
            } else if (dataPage === "job") {
              nearBy = "Similar jobs near by";
            } else if (dataPage === "business") {
              nearBy = "Similar services near by";
            }

            if (dataPage === "property" || dataPage === "event") {
              return (
                <React.Fragment key={index}>
                  {parseInt(currentLocationFlag) === parseInt(0) && parseInt(queryLocation) !== parseInt(1) && parseInt(index) === parseInt(0) && parseInt(queryPage) === parseInt(1) && <NoRecordFound />}

                  {parseInt(nearestLocation) === parseInt(1) && parseInt(queryLocation) !== parseInt(1) && (
                    <div>
                      <Divider />
                      <h3 className="content-sub-heading">
                        {nearBy}&nbsp;
                        <span className="similar-location">{"breadcrumbLocation"}</span>
                      </h3>
                    </div>
                  )}
                  <div className="col-lg-6 col-md-6 col-sm-12" key={index + "" + element.name}>
                    {dataPage === "property" && <Card align={"align-items-center"} justifycontent={"center"} image={element.image_name ? element.image_path : "DefaultRoom"} isImage={element.image_name ? element.image_path : false} title={element.name ? element.name : false} location={element.location ? element.location : false} postalcode={element.postal_code ? element.postal_code : false} page={element.page ? element.page : ""} type={pillsimilar} salary={element.amount ? element.amount : false} desc={element.detail ? element.detail : false} detail_url={element.page + "/" + element.slug} views={element.views} />}
                    {dataPage === "event" && <EventCard imageHeight="370px" image={element.image_name ? element.image_path : false} title={element.name ? element.name : ""} location={element.location ? element.location : ""} postalcode={element.postal_code ? element.postal_code : ""} page={element.page ? element.page : ""} type={element.category ? element.category.charAt(0).toUpperCase() + element.category.slice(1) : ""} startDate={element.start_date} startTicketDate={element.ticket_start_at} showStartDate={element.show_start_date} endDate={element.end_date} adultOnly={element.adult_event} detail_url={element.page + "/" + element.slug} views={element.views} price={element.tickets && element.tickets.length > 0 ? element.tickets[0].price : null} eventType={element.event_type} ticketingUrl={element.ticketing_url} internalHasTickets={element.tickets && element.tickets.length > 0} />}
                  </div>
                </React.Fragment>
              );
            } else if (dataPage === "business") {
              return (
                <React.Fragment key={index}>
                  {parseInt(currentLocationFlag) === parseInt(0) && parseInt(queryLocation) !== parseInt(1) && parseInt(index) === parseInt(0) && parseInt(queryPage) === parseInt(1) && <NoRecordFound />}

                  {parseInt(nearestLocation) === parseInt(1) && parseInt(queryLocation) !== parseInt(1) && (
                    <div>
                      <Divider />
                      <h3 className="content-sub-heading">
                        {nearBy}&nbsp;
                        <span className="similar-location">{"breadcrumbLocation"}</span>
                      </h3>
                    </div>
                  )}
                  <div className="col-lg-6 col-md-6 col-sm-12" key={index + "" + element.name}>
                    <BusinessCard imgaeWidth="305px" imageHeight="75px" align={"align-items-start"} justifycontent={"left"} image={element.image_thumbnail_path ? element.image_thumbnail_path : "DefaultBL"} title={element.name ? element.name : false} location={element.location ? element.location : false} postalcode={element.postal_code ? element.postal_code : false} page={element.page ? element.page : ""} type={pillsimilar} salary={element.salary_value ? element.salary_value : false} desc={element.detail ? element.detail : false} category_id={element.category_id} detail_url={element.page + "/" + element.slug} views={element.views} />
                  </div>
                </React.Fragment>
              );
            } else {
              return (
                <React.Fragment key={index}>
                  {parseInt(currentLocationFlag) === parseInt(0) && parseInt(queryLocation) !== parseInt(1) && parseInt(index) === parseInt(0) && parseInt(queryPage) === parseInt(1) && <NoRecordFound />}

                  {parseInt(nearestLocation) === parseInt(1) && parseInt(queryLocation) !== parseInt(1) && (
                    <div>
                      <Divider />
                      <h3 className="content-sub-heading">
                        {nearBy}&nbsp;
                        <span className="similar-location">{"breadcrumbLocation"}</span>
                      </h3>
                    </div>
                  )}
                  <div className="col-lg-12 col-md-12 col-sm-12" key={index + "" + element.name}>
                    <Card title={element.name ? element.name : false} location={element.location ? element.location : false} postalcode={element.postal_code ? element.postal_code : false} page={element.page ? element.page : ""} type={pillsimilar} salary={element.salary_value ? element.salary_value : false} desc={element.detail ? element.detail : false} detail_url={element.page + "/" + element.slug} views={element.views} />
                  </div>
                </React.Fragment>
              );
            }
          })
        : false}
      {data && data.length === 0 && (
        <div name="notfound">
          <NoRecordFound />
        </div>
      )}

      {data && data.length > 0 && paginationData && paginationData.links.length > 3 && (
        <div className="col-lg-12 col-md-12 col-sm-12 col-9">
          <Pagination totalPages={paginationData.last_page} currentPage={paginationData.current_page} onPageChange={handlePagination} />
        </div>
      )}
    </div>
  );
}

export default SearchResults;
